import { render, staticRenderFns } from "./navbar-box.vue?vue&type=template&id=ac3f07dc&"
import script from "./navbar-box.ts?vue&type=script&lang=ts&"
export * from "./navbar-box.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports